import YTPlayer from 'yt-player';
import { $Q, $Qll } from '../utils/querySelector.js';

/**
 * Class to use iframe youtube api
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
class IframYoutube {
  constructor() {
    this.containerVideoArray = $Qll('.js-hero-iframe-youtube');

    if (this.containerVideoArray) {
      this._initVideoLoop();
    }
  }

  /**
   * Init video loop
   * Get elements with iframes and initilize
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _initVideoLoop() {
    this.containerVideoArray.forEach((element) => {
      if (element) {
        this.videoLoop(element);
      }
    });
  }

  /**
   * Get element data
   * Init ifram youtube with YTPlayer
   * Render <iframe></iframe> with YTPlayer
   * @param {Node} element | obj container for iframe
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  videoLoop(element) {
    const idVideo = element.dataset.videoId;
    const width = element.dataset.width ? element.dataset.width : 3840;
    const height = element.dataset.height ? element.dataset.height : 2160;
    const idElement = element.id;

    // Check if element contains id
    if (!idElement) {
      return;
    }

    const player = new YTPlayer(`#${idElement}`, {
      showinfo: 0,
      autoplay: 1,
      autohide: 1,
      controls: 0,
      related: false,
      rel: 0,
      modestbranding: 1,
      loop: 1,
      fs: 0,
      disablekb: 1,
      width: width,
      height: height,
    });

    this._assignYoutubeEvents(player, idVideo, element);
  }

  /**
   *  Assing events of youtube to add our logic
   * @param {Object} player - Iframe object
   * @param {String} idVideo - Id youtube video
   * @param {HTMLElement} element - Wrapper
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _assignYoutubeEvents(player, idVideo, element) {
    player.getState();
    player.load(idVideo);
    player.mute();

    player.setPlaybackQuality('highres');
    player.on('unstarted', this._addDelayToDisplayVideo.bind(this, player, element));
    player.on('unplayable', () => player.play());
    player.on('ended', () => player.play());
    player.on('paused', () => player.play());
  }

  /**
   * Add delay to 3 seconds to display video
   * @param {Object} player - Iframe object
   * @param {HTMLElement} element - Element
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _addDelayToDisplayVideo(player, element) {
    player.setPlaybackQuality('highres');
    player.play();
    const wrapper = element ? element.closest('#js-hero-home-parent') : null;

    if (!wrapper) return
    player.on('playing', () => {
      setTimeout(() => {
        wrapper.classList.add('isPlay');
      }, 3000);
    });
  }
}

export { IframYoutube };
